import { connect } from 'react-redux';
import _ from 'lodash'; // TODO: refactor the chain method in mapStateToProps as to not import all of lodash

import DeleteEventModal from './DeleteEventModal';

const mapStateToProps = (state, ownProps) => {
  const { event } = ownProps;
  const guestGroups = state.guestList.guests.orderedIds.map(id => state.guestList.guests.byId[id]);
  const eventInvitationsWithResponse = _.chain(guestGroups)
    .flatMap(guestGroup => guestGroup.guests)
    .flatMap(guest => guest.event_invitations)
    .filter(
      eventInvitation => eventInvitation.event_id === event.id && eventInvitation.rsvp_at !== null
    )
    .value();
  return {
    numRsvpResponses: eventInvitationsWithResponse.length,
  };
};

export default connect(mapStateToProps)(DeleteEventModal);



// WEBPACK FOOTER //
// ./src/components/common/modals/DeleteEventModal/index.js